export const environment = {
  production: true,
  enforceHttps: true,
  apiRoute: 'https://boma-api-staging.azurewebsites.net/',
  supplierRoute: 'https://supplier-staging.boma.today/',
  adminRoute: 'https://admin-staging.boma.today/',
  websiteRoute: 'https://staging.boma.today/',
  apiVersion: '1.0',
  contextApiRoute: 'https://boma-api-supplier-staging.azurewebsites.net/',
  contextApiVersion: '1.0',
  firebaseConfig: {
    apiKey: 'AIzaSyDd4Seep-sZI7lZAZqzLTjoJm5zslv76go',
    authDomain: 'boma-4695e.firebaseapp.com',
    projectId: 'boma-4695e',
    storageBucket: 'boma-4695e.appspot.com',
    messagingSenderId: '274558524244',
    appId: '1:274558524244:web:544ba8322fce09baa986c1',
    measurementId: 'G-M7KXX6XY6K',
  },
  authentication: {
    issuer: 'https://auth-staging.boma.today/',
    clientId: 'staging-supplier-portal',
    scopes: 'openid offline_access api',
  },
  sageConfig: {
    apiKey: '{96485236-9F10-467C-BE21-A5E4B8285FB0}',
    url: 'https://resellers.accounting.sageone.co.za/api/2.0.0',
  },
};
